import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import template from "lodash.template";
import { normalizeArg } from "./functions";
export function createIconSet(data) {
  var dataCopy = normalizeArg(Object.assign({}, data));
  if (dataCopy.icon) return dataCopy;
  for (var _len = arguments.length, ancestors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    ancestors[_key - 1] = arguments[_key];
  }
  var fromAncestor = ancestors.reduce(function (prev, curr) {
    if (prev) return prev;
    var iconTemplate = curr.iconTemplate || curr.iconTemplate;
    if (iconTemplate) {
      return JSON.parse(template(iconTemplate)(dataCopy));
    } else if (curr.icon) {
      return {
        icon: curr.icon,
        selectedIcon: curr.selectedIcon || curr.selectedIcon
      };
    }
  }, undefined);
  if (fromAncestor) {
    dataCopy.icon = fromAncestor.icon;
    dataCopy.selectedIcon = fromAncestor.selectedIcon;
  }
  return dataCopy;
}
export function createHtmlFromTemplate(data) {
  data = normalizeArg(data);
  if (data.html) return data;
  for (var _len2 = arguments.length, ancestors = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    ancestors[_key2 - 1] = arguments[_key2];
  }
  return ancestors.reduce(function (prev, curr) {
    if (prev) return prev;
    var poiTemplate = curr.poiTemplate;
    if (poiTemplate) {
      data.html = template(poiTemplate)(data);
      data.poiStyle = data.poiStyle || curr.poiStyle;
      return data;
    }
  }, undefined) || data;
}